import { useEffect } from 'react'

export default function ExternalRoutes() {
  useEffect(() => {
    window.location.href = 'https://mail5.mailbox.pt/interface/root#/login'
  }, [])
  return <></>
}
